import { useContext, useEffect, useState } from "react";
import { cashnator, formatarData } from "../../utils/functions";
import { formatProductShipping, shippingSharedLabel } from "../../utils/formatProductShipping";
import { getGradingTypeLabel, getPreLacreFormatLabel, normalizeGradingType, priorityTypes } from "../../utils/gradingTypes";
import Button from "../../atoms/button";
import { getNextStatus, statusObject } from "../../utils/allProductStatus";
import LoadingOverlay from "../../atoms/loadingOverlay";
import { getSpecialPhrase, updateProductStatus } from "../functions";
import ToastContext from "../../../context/toastProvider";
import Modal from "../../utils/modal";
import EditModal from "./editModal";
import ProductHistory from "./productHistory";
import { createSerialFromDraft } from "../../serials/functions";
import { validateProductAutographNotes } from "../../utils/serialGradeFields";
import CheckoutGroupPanel from "../CheckoutGroupPanel";

const ProductInfo = ({ user, productData, refresh, stores }) => {

    const { goodToast, badToast } = useContext(ToastContext);

    const [alter, setAlter] = useState(false);
    const [edit, setEdit] = useState(false);
    const [status, setStatus] = useState(productData?.status);
    const [notify, setNotify] = useState(true);
    const [phrase, setPhrase] = useState("");
    const [returnTrackingCode, setReturnTrackingCode] = useState(productData?.returnTrackingCode || "");
    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState(false);
    const [isHQ, setIsHQ] = useState(true);

    useEffect(() => {
        if (stores?.length && productData) {
            const productStore = stores?.filter(s => s?._id === productData?.store?._id)[0];
            if (productStore) {
                setIsHQ(productStore?.headquarter);
            }
        }
    }, [stores, productData]);

    const doUpdateStatus = async () => {
        setLoading(true);
        setAlter(false);
        if (status === "GRADED") {
            const productSerials = Array.isArray(productData?.serials) ? productData.serials : [];
            if (productSerials.length < productData?.numberOfCards) {
                badToast("Seriais não preenchidos!");
                setLoading(false);
                return null;
            }
            const autographNotesValidation = validateProductAutographNotes({ ...productData, serials: productSerials });
            if (!autographNotesValidation.ok) {
                const messages = [];
                if (autographNotesValidation.missingCount > 0) {
                    messages.push(`${autographNotesValidation.missingCount} ${autographNotesValidation.missingCount === 1 ? "serial está sem nota de autógrafo" : "seriais estão sem nota de autógrafo"}`);
                }
                if (autographNotesValidation.invalidCount > 0) {
                    messages.push(`${autographNotesValidation.invalidCount} ${autographNotesValidation.invalidCount === 1 ? "serial tem nota de autógrafo inválida" : "seriais têm nota de autógrafo inválida"}`);
                }
                badToast(`Revise as notas de autógrafo antes de concluir a graduação: ${messages.join(" e ")}.`);
                setLoading(false);
                return null;
            }
            const newSerials = productSerials.filter(d => d?.isDraft);
            for (let i = 0; i < newSerials?.length; i++) {
                const current = newSerials[i];
                const gradedData = await createSerialFromDraft(user?.token, current?._id);
                if (gradedData?.type === "error") {
                    badToast(gradedData?.message);
                    setLoading(false);
                    return null;
                }
            }
        }
        const data = await updateProductStatus(user?.token, productData?._id, status, notify, statusObject[status], returnTrackingCode, user?.email);
        if (data?.type === "success") {
            goodToast("Status do produto atualizado!");
            refresh();
        }
        if (data?.type === "error") {
            badToast(data?.message);
        }
        setLoading(false);
    }

    const doGetSpecialPhrase = async () => {
        setLoading(true);
        const data = await getSpecialPhrase(user?.token, productData?._id);
        if (data?.type === "error") {
            badToast(data?.message);
            setLoading(false);
            return null;
        }
        if (data?.type === "success") {
            setPhrase(data?.data);
        }
        setLoading(false);
    }

    const openAlter = () => {
        const next = getNextStatus(productData?.delivery, productData?.status, isHQ)
        if (next) {
            setStatus(next);
        }
        if(productData?.status === "ANALYZING"){
            setStatus("ANALYZING");
        }
        setAlter(true);
    }

    const closeAlter = () => {
        setStatus(productData?.status);
        setAlter(false);
    }

    return (
        <div className="m-4 border border-[#666] p-2 relative bg-monao">
            <h2 className="text-center text-lg mb-4">Detalhes do pedido</h2>
            <div className="absolute top-2 right-2 flex gap-2">
                <Button classes="bg-primary" click={() => setHistory(true)}>Ver histórico</Button>
                <Button classes="bg-primary" click={() => setEdit(true)}>Editar</Button>
            </div>
            <div className="flex gap-10 w-fit m-auto flex-wrap justify-center gap-y-2">
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Tipo</p>
                    <p className="m-0 text-lg">{getGradingTypeLabel(productData?.gradingType)}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Autógrafo</p>
                    <p className="m-0 text-lg">{productData?.autographEvaluation ? "Sim" : "Não"}</p>
                </div>
                {
                    normalizeGradingType(productData?.gradingType) === "pre" && productData?.preLacreFormat ?
                        <div className="text-center w-fit max-w-[220px]">
                            <p className="m-0 text-sm text-[#999] -mb-2">Pré — formato do lacre</p>
                            <p className="m-0 text-sm leading-tight">{getPreLacreFormatLabel(productData?.preLacreFormat)}</p>
                        </div>
                        : null
                }
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Nº de itens</p>
                    <p className="m-0 text-lg">{productData?.numberOfCards}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Prioridade</p>
                    <p className="m-0 text-lg">{priorityTypes[productData?.priority]}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Prazo</p>
                    <p className="m-0 text-lg">{productData?.deadline}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Entrega</p>
                    <p className="m-0 text-lg">{productData?.delivery}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Preço final</p>
                    <p className="m-0 text-lg">{cashnator(productData?.finalPrice)}</p>
                </div>
                {productData?.declaredValueAllocationMode === "proportional_cards"
                    || typeof productData?.declaredValueOrderTotalCents === "number"
                    ? null
                    : (
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Valor itens</p>
                            <p className="m-0 text-lg">{cashnator(productData?.cardsValue)}</p>
                        </div>
                    )}
                {productData?.checkoutSessionId || productData?.asaasPaymentId
                    ? null
                    : (
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Taxa de manuseio</p>
                            <p className="m-0 text-lg">{cashnator(productData?.insurance)}</p>
                        </div>
                    )}
                {
                    productData?.delivery === "correios" ?
                        (() => {
                            const sharedNote = shippingSharedLabel({
                                shippingShared: productData?.shippingShared === true
                                    || (productData?.checkoutItemCount > 1),
                                checkoutItemCount: productData?.checkoutItemCount,
                                shippingChargedOnThisProduct: productData?.shippingChargedOnThisProduct,
                            });
                            return (
                                <div className="text-center w-fit max-w-[16rem]">
                                    <p className="m-0 text-sm text-[#999] -mb-2">Valor frete</p>
                                    <p className="m-0 text-lg">
                                        {formatProductShipping(productData?.shipping, {
                                            checkoutSessionId: productData?.checkoutSessionId,
                                        }) || "—"}
                                    </p>
                                    {sharedNote ? (
                                        <p className="m-0 mt-1 text-xs text-[#b47c06]">{sharedNote}</p>
                                    ) : null}
                                </div>
                            );
                        })()
                        : null
                }
                {
                    productData?.delivery === "correios" ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Tipo frete</p>
                            <p className="m-0 text-lg">{productData?.shippingService}</p>
                        </div>
                        : null
                }
                {
                    productData?.delivery === "correios" ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Rastreio</p>
                            <p className="m-0 text-lg">{productData?.trackingCode}</p>
                        </div>
                        : null
                }
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Criado em</p>
                    <p className="m-0 text-lg">{formatarData(productData?.createdAt)}</p>
                </div>
                {
                    productData?.paidAt ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Pago em</p>
                            <p className="m-0 text-lg">{formatarData(productData?.paidAt)}</p>
                        </div>
                        : null
                }
                {
                    productData?.checkoutSessionId || productData?.asaasPaymentId ? (
                        <div className="w-full basis-full">
                            <CheckoutGroupPanel
                                variant="desktop"
                                token={user?.token}
                                productId={productData?._id}
                                productStatus={productData?.status}
                                checkoutSessionId={productData?.checkoutSessionId}
                                asaasPaymentId={productData?.asaasPaymentId}
                                productShipping={productData?.shipping}
                                productInsurance={productData?.insurance}
                                shippingShared={productData?.shippingShared}
                                checkoutItemCount={productData?.checkoutItemCount}
                                shippingChargedOnThisProduct={productData?.shippingChargedOnThisProduct}
                                declaredValueOrderTotalCents={productData?.declaredValueOrderTotalCents}
                                declaredValueAllocationMode={productData?.declaredValueAllocationMode}
                                userEmail={user?.email}
                                onStatusUpdated={refresh}
                            />
                        </div>
                    ) : null
                }
                {
                    productData?.createdByAdmin === true || productData?.createdByAdmin === false ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Criado por Admin</p>
                            <p className="m-0 text-lg">{productData?.createdByAdmin ? 'Sim' : 'Não'}</p>
                        </div>
                        : null
                }
                {
                    productData?.paymentMethod ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Forma de Pagamento</p>
                            <p className="m-0 text-lg">{productData?.paymentMethod === 'PIX' ? "PIX" : (productData?.paymentMethod === 'CREDIT_CARD' ? "Cartão de Crédito" : '')}</p>
                        </div>
                        : null
                }
                {
                    productData?.receivedAt ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Recebido em</p>
                            <p className="m-0 text-lg">{formatarData(productData?.receivedAt)}</p>
                        </div>
                        : null
                }
                {
                    productData?.receivedAt ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Data prazo</p>
                            <p className="m-0 text-lg">{formatarData(productData?.calculatedDeadline)}</p>
                        </div>
                        : null
                }
            </div>
            <div className="flex gap-2 w-fit m-auto my-4">
                <p>Status: <strong>{statusObject[productData?.status]}</strong></p>
                <div>
                    <Button classes="bg-primary" click={openAlter}>Alterar</Button>
                </div>
            </div>

            <div>
                {
                    productData?.coupon ?
                        <div className="border border-green-700 mb-4 w-fit p-2 m-auto text-green-500 text-center">
                            <p>Cupom: <strong>{productData?.coupon?.code}</strong></p>
                            <p>Valor do desconto: <strong>{productData?.coupon?.kind === "amount" ? "R$" : null}{productData?.coupon?.value?.toFixed(2)}{productData?.coupon?.kind === "percent" ? "%" : null}</strong></p>
                        </div>
                        : null
                }
                {
                    productData?.returnTrackingCode ?
                        <div className="flex w-fit m-auto gap-2 my-4">
                            <label></label>
                            <p className="text-center">Código de rastreio (retorno): <strong>{productData?.returnTrackingCode}</strong></p>
                        </div>
                        : null
                }
                {
                    productData?.delivery === "correios" ?
                        <div className="w-fit m-auto border border-[#777] px-4">
                            <p className="text-center border-b border-[#777] py-2 mb-2">Endereço</p>
                            <div className="flex flex-wrap justify-center gap-4 m-4">
                                <div className="">
                                    <p className="-mb-2 text-center text-sm text-[#666]">CEP</p>
                                    <p className="text-center">{productData?.postalCode}</p>
                                </div>
                                <div className="">
                                    <p className="-mb-2 text-center text-sm text-[#666]">Rua</p>
                                    <p className="text-center">{productData?.street}</p>
                                </div>
                                <div className="">
                                    <p className="-mb-2 text-center text-sm text-[#666]">Bairro</p>
                                    <p className="text-center">{productData?.district}</p>
                                </div>
                                <div className="">
                                    <p className="-mb-2 text-center text-sm text-[#666]">Cidade</p>
                                    <p className="text-center">{productData?.city}</p>
                                </div>
                                <div className="">
                                    <p className="-mb-2 text-center text-sm text-[#666]">Estado</p>
                                    <p className="text-center">{productData?.state}</p>
                                </div>
                                <div className="">
                                    <p className="-mb-2 text-center text-sm text-[#666]">País</p>
                                    <p className="text-center">{productData?.country}</p>
                                </div>
                                <div className="">
                                    <p className="-mb-2 text-center text-sm text-[#666]">Número</p>
                                    <p className="text-center">{productData?.houseNumber}</p>
                                </div>
                                <div className="">
                                    <p className="-mb-2 text-center text-sm text-[#666]">Complemento</p>
                                    <p className="text-center">{productData?.complement}</p>
                                </div>
                            </div>
                        </div>
                        : <p className="text-center my-4">Loja: <strong>{stores?.filter(s => s?._id === productData?.store?._id)[0]?.name}</strong></p>
                }
                <div className="flex flex-col my-4">
                    <Button classes="bg-purple-400 hover:bg-purple-600 w-1/3" click={doGetSpecialPhrase}
                        disabled={["CART", "GENERATED", "PIX", "PROCESSED", "PENDING", "APPROVED", "CANCELED"].includes(productData?.status) || phrase !== ""}>
                        Ver Frase Secreta
                    </Button>
                    <p className="p-2 font-bold text-[#d59106] text-center m-auto]">{phrase}</p>
                </div>
            </div>
            <LoadingOverlay loading={loading} />
            {
                alter ?
                    <Modal handleClose={closeAlter}>
                        <div className="relative">
                            <a className="w-10 h-10 rounded-full border border-laranjinha cursor-pointer flex items-center justify-center font-bold absolute bottom-0 right-0 text-xl bg-primary text-black" href="/manafix/status" target="_blank" rel="noreferrer" title="Clique para ver a lista de status">?</a>
                            {
                                productData?.status === "ANALYZING" ?
                                    null
                                    :
                                    getNextStatus(productData?.delivery, productData?.status, isHQ) ?
                                        <p className="text-center">O status atual do pedido é <strong className="text-green-500">{statusObject[productData?.status]}</strong>. O próximo status do fluxo seria <strong className="text-green-500">{statusObject[getNextStatus(productData?.delivery, productData?.status, isHQ)]}</strong>, o qual já foi pré-selecionado na lista abaixo.</p>

                                        :
                                        <p className="text-center">O status atual do pedido é {statusObject[productData?.status]}. Este é o status final do fluxo.</p>
                            }
                            <div className="flex gap-2 w-fit m-auto my-4">

                                <p>Status: </p>
                                <select disabled={!alter} className="text-black text-center px-2" value={status} onChange={e => setStatus(e.target.value)}>
                                    {
                                        Object.keys(statusObject).map((s, i) => (
                                            <option key={i} value={s}>{statusObject[s]}</option>
                                        ))
                                    }
                                </select>

                            </div>
                            {
                                status === "RETURNED" ?
                                    <div className="flex w-fit m-auto gap-2 my-4">
                                        <label>Código de rastreio (retorno)</label>
                                        <input type="text" className="text-black text-center" value={returnTrackingCode} onChange={e => setReturnTrackingCode(e.target.value)} />
                                    </div>
                                    : null
                            }
                            <div className="mb-4 w-fit m-auto">
                                <label className="mr-2">Notificar usuário: </label>
                                <input type="checkbox" defaultChecked={notify} onChange={() => setNotify(!notify)} />
                            </div>
                            <div className="flex gap-2 w-fit m-auto">
                                <Button classes="bg-green-500 hover:bg-green-300" disabled={status === productData?.status && returnTrackingCode === productData?.returnTrackingCode} click={doUpdateStatus}>Alterar</Button>
                                <Button classes="bg-red-500 hover:bg-red-300" click={closeAlter}>Cancelar</Button>
                            </div>
                        </div>
                    </Modal>
                    : null
            }
            {
                edit ?
                    <EditModal handleClose={() => setEdit(false)} stores={stores} productData={productData} refresh={refresh} />
                    : null
            }
            {
                history ?
                    <ProductHistory user={user} product={productData} close={() => setHistory(false)} refresh={refresh} />
                    : null
            }
        </div>
    )
}

export default ProductInfo;
